import { AuthenticationPlatform } from 'src/contexts/AuthContext';

export const internalAuthPlatforms = [AuthenticationPlatform.Auth0, AuthenticationPlatform.JWT];
export const externalAuthPlatforms = [AuthenticationPlatform.BankIdNo, AuthenticationPlatform.BankIdSe];
